export interface IPresentableFixedAspectRatio {
  isAspectRatioFixed(): boolean;
}

export function instanceOfIPresentableFixedAspectRatio(instance: any): instance is IPresentableFixedAspectRatio {
  return !!instance
      && !!instance.isAspectRatioFixed;
}
